import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo } from '@apexdesigner/schema-tools';

export const serviceTaskHistory = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    eventType: z
      .enum(['Created', 'Claimed', 'Completed', 'Error Occurred', 'Retry'])
      .describe('What happened to the task'),

    data: z
      .unknown()
      .nullable()
      .optional()
      .presentAs('json')
      .describe('Additional details about what changed'),

    timestamp: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('When this event occurred'),

    serviceTaskId: z.uuid().hidden().describe('Foreign key to ServiceTask'),

    serviceTask: belongsTo('ServiceTask'),
  })
  .describe('Records each action taken on a service task')
  .as('ServiceTaskHistory');

export { serviceTaskHistory as serviceTaskHistorySchema };
